export default function QuickEligibilitySection() {
  return (
    <section className="py-16 md:py-20 bg-white">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-4xl font-bold text-[#1B4D3E] text-center mb-4">
          Can You Renew Fast? Check in 30 Seconds
        </h2>
        <p className="text-gray-600 text-center mb-10 max-w-2xl mx-auto">
          Fast renewal by mail (Form DS-82) is the quickest path. You qualify if <strong>ALL FOUR</strong> of these are true:
        </p>

        <div className="bg-[#f0f9f4] border border-green-200 rounded-lg p-6 md:p-8 mb-8">
          <ul className="space-y-4">
            {[
              "Your passport was issued when you were 16 or older",
              "Your passport was issued within the last 15 years",
              "Your passport is undamaged (no water damage, torn pages, or mutilation)",
              "Your name hasn't changed — OR you have a legal document proving the change (marriage certificate, divorce decree, court order)",
            ].map((item, i) => (
              <li key={i} className="flex items-start gap-3 text-gray-800">
                <span className="flex-shrink-0 w-6 h-6 rounded-full bg-[#1B4D3E] flex items-center justify-center mt-0.5">
                  <i className="ri-check-line text-white text-sm"></i>
                </span>
                <span className="text-base md:text-lg">{item}</span>
              </li>
            ))}
          </ul>
        </div>

        <div className="text-center">
          <p className="text-lg text-gray-800 font-semibold mb-4">
            Great news — you qualify for fast renewal by mail. No office visit, no acceptance facility, no appointment.
          </p>
          <a
            href="https://fastpassportcenter.com/checkout/?passport=passport-renewal"
            className="whitespace-nowrap inline-flex items-center gap-2 px-7 py-3.5 bg-[#C8A951] hover:bg-[#b8942e] text-[#1B4D3E] font-bold text-base rounded-md transition-colors cursor-pointer"
          >
            <i className="ri-rocket-line text-lg"></i>
            Start My Fast Renewal
          </a>
        </div>

        <div className="mt-8 pt-6 border-t border-gray-200 text-center">
          <p className="text-gray-500 text-sm">
            Don't qualify for all four? You may need a new passport application instead.{" "}
            <a href="/passport-services/new-passport/" className="text-[#1B4D3E] font-semibold underline hover:text-[#2d8a5e] cursor-pointer">
              See our New Passport page
            </a>{" "}
            or call <a href="tel:8772530084" className="text-[#1B4D3E] font-semibold whitespace-nowrap cursor-pointer">877-253-0084</a> — we'll tell you exactly what you need in 2 minutes.
          </p>
        </div>
      </div>
    </section>
  );
}